

exports.__esModule = true;
exports.$GamblingBlockEnabled = undefined;

var _squid = require('squid');

require('./directive');

var $GamblingBlockEnabled = exports.$GamblingBlockEnabled = _squid.$ComponentRoute.extend('$GamblingBlockEnabled', {
    path: 'gamblingBlockEnabled',
    directive: 'xo-gambling-block-enabled-page',
    titleContent: 'gamblingBlockEnabled.headingn',
    query: ['message'],
    trackingData: {
        templateName: 'gamblingBlockEnabled.dust',
        pageGoal: 'Gambling Block Enabled page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-gambling-block-enabled',
                'pagename2': '%::fullpage-gambling-block-enabled:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$GamblingBlockEnabled", $GamblingBlockEnabled);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-gambling-block-enabled/route.js
// module id = ./pages/xo-gambling-block-enabled/route.js
// module chunks = 0